import React, { Component } from 'react';
import moment from 'moment';
import withStyles from '@material-ui/core/styles/withStyles';
import _ from 'lodash';

import Modal from '@material-ui/core/Modal';
import MaterialTable, { MTableToolbar } from 'material-table';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import BarChartIcon from '@material-ui/icons/BarChart';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import Checkbox from '@material-ui/core/Checkbox';
import { FaStopCircle } from 'react-icons/fa';

import { BASE_URL } from 'consts';
import { getTemplateFriendlyType } from 'templates';
import { DialogAnalytics } from './AnalyticsDialogs';
import DataList from '../../../Analytics/components/DataList';
import { RenderIconButton } from './GenericComponents';
import { Preview } from 'routes/Dashboard/Template';
import { UrlBox } from '../../shared';
import InfoBox from '../../../../../components/InfoBox/InfoBox';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/styleEvent.css';

const styles = () => ({
  preview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textBold: {
    fontWeight: 'bold',
  },
  textBoldColor: {
    fontWeight: 'bold',
    color: '#0084ff',
  },
  textBoldColorHost: {
    fontWeight: 'bold',
    color: '#eb8315',
  },
});

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

export class ChannelEventInteractionTable extends Component {
  state = {
    preview: null,
    invalidPass: false,
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  renderInteractionPreview(classes, auth) {
    const { preview } = this.state;
    const previewUrl =
      preview && auth && auth.user
        ? `${BASE_URL}/template/${preview.type}/preview/${preview.id}/${auth.user._id}`
        : null;

    return (
      <Preview
        open={Boolean(this.state.preview)}
        onClose={() => this.setState({ preview: null })}
        url={
          this.state.preview && this.state.preview.redirect
            ? this.state.preview.redirect
            : previewUrl
        }
      />
    );
  }

  render() {
    const {
      classes,
      auth,
      access,
      interactionsList,
      interactionsPageSize,
      closeInteraction,
      stopScreens,
      showInteractionsClosed,
      updateShowClosed,
      fetchInteractionAnalytics,
      interactionAnalytics,
      filterOption,
      sendStatistics,
      analyticsDialog,
      onCloseDialogAnalytics,
      dataListView,
      usersAnalytics,
      closeDataListView,
      isAnalyticsPage,
      rowAction,
    } = this.props;

    const questionsAnalytics = _.get(interactionAnalytics, 'data', null);
    const interactionTitle = _.get(interactionAnalytics, 'title', null);
    const hasAnalyticData = questionsAnalytics !== null ? true : false;

    const handleRowAction = rowAction instanceof Function ? rowAction : () => {};

    const columns = [
      {
        cellStyle: { padding: '4px 15px 4px 15px' },
        headerStyle: { padding: '4px 15px 4px 15px' },
        title: 'Template name',
        field: 'params.category',
        customSort: (a, b) =>
          a.params.category.toLowerCase().localeCompare(b.params.category.toLowerCase()),
      },
      {
        cellStyle: { padding: '4px 15px 4px 15px' },
        headerStyle: { padding: '4px 15px 4px 15px' },
        title: 'Display title',
        field: 'name',
        customSort: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
      },
      {
        cellStyle: { padding: '4px 15px 4px 15px' },
        headerStyle: { padding: '4px 15px 4px 15px' },
        title: 'Type',
        field: 'type',
        render: rowData => getTemplateFriendlyType(rowData.type),
      },
      {
        cellStyle: { padding: '4px 15px 4px 15px' },
        headerStyle: { padding: '4px 15px 4px 15px' },
        title: 'Published At',
        field: 'publishedAt',
        render: rowData => (
          <div>{moment(rowData.publishedAt).format('MMMM Do YYYY, h:mm:ss a')}</div>
        ),
        defaultSort: 'desc',
        type: 'date',
      },
      {
        cellStyle: { padding: '4px 15px 4px 15px' },
        headerStyle: { padding: '4px 15px 4px 15px' },
        title: 'Received / Opened',
        field: '',
        render: rowData => rowData.msgReceived + ' / ' + rowData.msgOpened,
        customSort: (a, b) => a.msgReceived - b.msgReceived,
      },
      {
        cellStyle: { padding: '4px 15px 4px 15px' },
        headerStyle: { padding: '4px 15px 4px 15px' },
        title: 'Engagement',
        field: '',
        render: rowData => {
          return rowData.engagement + `%`;
        },
        customSort: (a, b) => {
          return a.engagement - b.engagement;
        },
      },
    ];

    const optionColumn = {
      cellStyle: { padding: '4px 15px 4px 15px' },
      headerStyle: { padding: '4px 15px 4px 15px' },
      title: 'Options',
      field: 'active',
      render: row => (
        <div>
          <React.Fragment>
            {row.active && access === 'host' ? (
              <RenderIconButton
                clickEvent={() => closeInteraction(this.props, row)}
                title={'Click to stop this Interaction'}
                placement={'top'}
                icon={<FaStopCircle className={classes.stopIcon} />}
                color={'primary'}
                theme={access}
              />
            ) : (
              ''
            )}

            <RenderIconButton
              clickEvent={() => {
                fetchInteractionAnalytics(row._id);
              }}
              title={'Click to view the data from Interaction'}
              placement={'top'}
              icon={<BarChartIcon className={classes.stopIcon} />}
              color={'primary'}
              theme={access}
            />

            <div style={{ display: 'flex' }}>
              {row.active && access === 'host' ? (
                <RenderIconButton
                  clickEvent={() => stopScreens(this.props, row)}
                  title={'Click to close some screens'}
                  placement={'top'}
                  icon={<SkipNextIcon className={classes.stopIcon} />}
                  color={'primary'}
                  theme={access}
                />
              ) : (
                ''
              )}

              {row.active && row.standalone ? (
                <UrlBox
                  title="Stand-Alone Interaction Links"
                  path={`/interaction/${row._id}`}
                  demo
                />
              ) : (
                ''
              )}
            </div>

            {!row.active ? <span style={{ padding: '4.1px' }}>Closed</span> : ''}
          </React.Fragment>
        </div>
      ),
      sorting: false,
    };

    if (!isAnalyticsPage) {
      columns.push(optionColumn);
    }

    return (
      <React.Fragment>
        <div style={{ width: '100%', minWidth: '550px' }}>
          <div
            style={{
              marginBottom: '10px',
              width: '100%',
            }}
          >
            <MaterialTable
              dense
              elevation={0}
              xs={12}
              options={{
                pageSizeOptions: [5, 10, 20],
                pageSize: interactionsPageSize,
                toolbar: true,
                paging: true,
                emptyRowsWhenPaging: false,
              }}
              columns={columns}
              data={interactionsList}
              onRowClick={(event, rowData) => handleRowAction(rowData)}
              title={
                <div className="title-info">
                  <span className="title-info-text">Interactions</span>
                  <span className="title-info-icon">
                    <InfoBox>
                      <p>
                        Created from templates,{' '}
                        <span className={classes.textBold}>Interactions</span>
                      </p>
                      <p>
                        {' '}
                        are{' '}
                        <span
                          className={
                            access === 'admin'
                              ? classes.textBoldColor
                              : classes.textBoldColorHost
                          }
                        >
                          'mini-games'
                        </span>
                        ,{' '}
                        <span
                          className={
                            access === 'admin'
                              ? classes.textBoldColor
                              : classes.textBoldColorHost
                          }
                        >
                          'questionnaires'
                        </span>
                        ...
                      </p>
                      <p>that the users will interact with.</p>
                    </InfoBox>
                  </span>
                </div>
              }
              components={{
                Toolbar: props => (
                  <div>
                    <MTableToolbar style={{ float: 'right' }} {...props} />
                    {!isAnalyticsPage && (
                      <div
                        style={{
                          margin: '0px',
                          width: '100%',
                          display: 'inline-block',
                        }}
                      >
                        <FormControlLabel
                          style={{ float: 'right' }}
                          control={
                            <Checkbox
                              checked={showInteractionsClosed}
                              onChange={() => {
                                updateShowClosed(showInteractionsClosed);
                              }}
                              color="primary"
                            />
                          }
                          label="Show closed Interactions"
                        />
                      </div>
                    )}
                  </div>
                ),
              }}
            />
          </div>

          {this.renderInteractionPreview(classes, auth)}
        </div>
        {!_.isEmpty(interactionAnalytics) && interactionAnalytics !== null ? (
          <div style={{ width: '100%' }}>
            <DialogAnalytics
              open={analyticsDialog}
              access={access}
              onClose={onCloseDialogAnalytics}
              interactionTitle={interactionTitle}
              hasAnalyticData={hasAnalyticData}
              questionsAnalytics={questionsAnalytics}
              filterOption={filterOption}
              sendStatistics={sendStatistics}
              graphRef={this.graphRef}
              ref={this.refff}
            />

            <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={dataListView}
              onClose={() => closeDataListView(false)}
              className={classes.preview}
            >
              <div className={classes.containerUsersAnalyticsView}>
                <div style={{ textAlign: 'center' }}>
                  <DataList listUsersInteraction={usersAnalytics} />
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ChannelEventInteractionTable);
